"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchCheckTrustedVerificationStatus = void 0;
const fetchCheckTrustedVerificationStatus = (api, progressId, body, url) => api.POST(url, body, {
    headers: {
        progressId,
    },
});
exports.fetchCheckTrustedVerificationStatus = fetchCheckTrustedVerificationStatus;
//# sourceMappingURL=resolver.js.map